document.onreadystatechange = function(event) {

    if (document.readyState === "loading") {

        if (window.location.hash !== null && window.location.hash !=='') {
        
            var target = window.location.hash;
            window.location.hash = "";
            history.pushState("", document.title, window.location.pathname);

        }

    }

};

jQuery(document).ready(function() {

    //var obj = {}; // var obj = new Object();
    function scrollTo( obj ) {
   
        let pos = parseInt( obj.position().top - 130);
    
        jQuery('html, body').animate(
            {scrollTop: pos},
            400,
            'easeInOutSine', 
            function() { history.pushState("", document.title, window.location.pathname); }
        ); 
        // .animate( properties [, duration ] [, easing ] [, complete ] )
    }
   
    // Starting scrolling
    if ( typeof target !== 'undefined' ) {

        let objToScroll = jQuery( target );
        target = '';
        scrollTo( objToScroll );

    }

	jQuery('a[href="#kontaktaoss"],a[href="#valkommen"],a[href="#evenemang"],a[href="#nyheter"],a[href="#fourth"]').click(function( event ) {

        event.preventDefault();

        let target = this.hash; // location.hash => Get the anchor part of the URL => #anchor
        let jQuerytarget = jQuery(target);
        let url=location.protocol+'//'+location.host+location.pathname;
        let url_root=wpajax.WP_SITE_URL+'/';

        // var url_root='https://'+location.host+'/'; // Deprecated by Carlos 2022-01-13
        // var url=('http://'+location.hostname+":8888"+location.pathname);
        // var url_root='http://'+location.hostname+':8888/jujutsukai.wp/';

        if (url!==url_root){
            
                jQuery(location).attr('href',url_root+target);

        } else {

                scrollTo( jQuerytarget );

        }

        if (jQuery('.bt-menu').is(':visible')) {

            if (jQuery('nav').css('left')=='0px') {

                contador = 1;
                jQuery('nav').animate ({left: '-100%'});

            }

        }

    });

});
